import { render } from "./ColorItem.vue?vue&type=template&id=9a74e658"
import script from "./ColorItem.vue?vue&type=script&lang=js"
export * from "./ColorItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__